import React from "react"
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { MenuItem, SubMenu } from "react-pro-sidebar";
import { Typography } from "@mui/material";

import { NavigationBar, SchoolPages, } from "../../helper";
import { setYear, setClassId, setClassName, setSubjectId, setSubjectName, setCategoryIndex, setClassNavId, setOverviewTabIndex } from "../../store/markingSlice";

import MarkingLogo from "../../assets/images/MarkingLogo.png"
import OverviewLogo from "../../assets/images/Overview.svg"
import MarkingLogoSelected from "../../assets/images/MarkingSelected.svg"
import OverviewLogoSelected from "../../assets/images/OverviewSelected.svg"

const OverViewMarking = (props) => {
  const { name, id, i, classId, className, iOne, setSelectTab, handleNavSelect, setSelectedClass, year, subjectImage, } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const subOverviewId = useSelector(state => state.marking.classNavId);
  const subjectName = useSelector(state => state.marking.subjectName);
  const select = useSelector((state) => state.styleData.select);
  const isSubMenuOpen = ((subOverviewId === `${i}-M` || subOverviewId === `${i}-O`) && subjectName === name && select === NavigationBar.MyClasses);

  const handleSubjectClick = (subjectClassId, _name, key) => {
    handleNavSelect(`${key}-M`);
    dispatch(setYear(year));
    dispatch(setClassId(classId));
    dispatch(setClassName(className));
    dispatch(setSubjectId(id));
    dispatch(setSubjectName(_name));
    dispatch(setCategoryIndex(0));
    dispatch(setClassNavId(`${key}-M`));
    setSelectTab(false)
    setSelectedClass(iOne)
    navigate(SchoolPages.subjectMarkings);
    if (isSubMenuOpen) {
      dispatch(setClassNavId(""));
    } else {
      dispatch(setClassNavId(`${key}-M`));
    }
  }

  const handleOverviewClick = (subjectId, _name, key) => {
    handleNavSelect(`${key}-O`);
    dispatch(setYear(year));
    dispatch(setClassId(classId));
    dispatch(setClassName(className));
    dispatch(setSubjectId(id));
    dispatch(setSubjectName(_name));
    dispatch(setClassNavId(`${key}-O`));
    dispatch(setOverviewTabIndex(0));
    setSelectTab(false)
    setSelectedClass(iOne)
    navigate(SchoolPages.subjectOverview)
  }

  const handleMarkingClick = (subjectClassId, _name, key) => {
    handleNavSelect(`${key}-M`);
    dispatch(setYear(year));
    dispatch(setClassId(classId));
    dispatch(setClassName(className));
    dispatch(setSubjectId(id));
    dispatch(setSubjectName(_name));
    dispatch(setCategoryIndex(0));
    dispatch(setClassNavId(`${key}-M`));
    setSelectTab(false)
    setSelectedClass(iOne)
    navigate(SchoolPages.subjectMarkings);
  }

  return (
    <div>
      <SubMenu label={name} style={isSubMenuOpen ? { color: "#FFA177" } : { color: "#FFF" }} icon={<img src={subjectImage} alt="subjectImage" />} onClick={() => { handleSubjectClick(classId, name, i) }} open={isSubMenuOpen}>
        {isSubMenuOpen && <div>
          <MenuItem style={(subOverviewId === `${i}-M` && subjectName === name) ? { color: "#FFA177" } : { color: "#FFF" }} onClick={() => { handleMarkingClick(classId, name, i) }} icon={<img src={subOverviewId === `${i}-M` ? MarkingLogoSelected : MarkingLogo} alt="markingLogo" />} >
            <Typography>{NavigationBar.Marking}</Typography>
          </MenuItem>
          <MenuItem style={(subOverviewId === `${i}-O` && subjectName === name) ? { color: "#FFA177" } : { color: "#FFF" }} onClick={() => { handleOverviewClick(classId, name, i) }} icon={<img src={subOverviewId === `${i}-O` ? OverviewLogoSelected : OverviewLogo} alt="OverviewLogo" />} >
            <Typography>{NavigationBar.Overview}</Typography>
          </MenuItem>
          {/* {assessWriting && <MenuItem icon={<img src={AssessLogo} alt="AssessLogo" />} style={{ color: "#FFF" }} >
                        <Typography>{NavigationBar.Assessment}</Typography>
                    </MenuItem>} */}
        </div>}
      </SubMenu>
    </div>

  )
}

export { OverViewMarking }
